module.exports = __webpack_public_path__ + "src/assets/jp.e79b0acf.png";